module.exports = __webpack_public_path__ + "img/file-chart-pie.11f1e912.svg";